/**
 * @module experience/credit-check
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { ObjectInterface } from '@support/api/common/api-response.interface';
import { IdentificationDetails } from '@experience/shop/credit-check/models/credit-check-identification-details.model';
import { PhoneDetails } from '@experience/shop/credit-check/models/credit-check-phone-details.model';

export class CreditCheckRequestModel {
  /**
   * Stores a flag for credit consent to the customer
   */
  public creditConsent: boolean;

  /**
   * Stores the type of customer account
   */
  public customerType: string;
  public firstName: string;
  public lastName: string;
  public MI: string;
  public addressId: string;
  public identification: IdentificationDetails;
  public communication: PhoneDetails;
  constructor(
    nameAddressFormValue: ObjectInterface,
    identificationFormValue: ObjectInterface,
    communicationFormValue: ObjectInterface,
    addressId: string,
    birthDate: string
  ) {
    this.creditConsent = true;
    if (nameAddressFormValue) {
      this.customerType = nameAddressFormValue.accSubType || '';
      this.firstName = nameAddressFormValue.firstName;
      this.lastName = nameAddressFormValue.lastName;
      this.MI = nameAddressFormValue.middleName;
    }
    this.addressId = addressId;
    this.identification = new IdentificationDetails(identificationFormValue, birthDate);
    this.communication = new PhoneDetails(communicationFormValue);
  }
}
